/*
 *   File : manage-risk.js
 *   Author : https://evoqins.com
 *   Description : Manage risk assessment page
 *   Integrations : 'react-router-dom , react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// custom components
import { PrimaryButton } from '../../Components/Buttons';
import { CustomTextInput } from '../../Components/FormElements';
import { APIService } from '../../Service';

const ManageRisk = () => {

    const navigate = useNavigate();
    const isRendered = useRef(true);

    const [styleScoreList, setStyleScoreList] = useState([
        {
            name: "",
            score_from: "",
            score_to: "",
        }
    ]);

    const [errors, setErrors] = useState(styleScoreList.map(() => ({
        name: "",
        score_from: "",
        score_to: "",
    })));

    const [loader, setLoader] = useState(false);


    useEffect(() => {
        if (isRendered.current === true) {
            _getStyleScore();
        }
        isRendered.current = false;
    }, [])


    const _handleRiskScoreChange = (value, field, index) => {

        setStyleScoreList(prev => {
            const updated_score = [...prev];
            updated_score[index][field] = value;
            return updated_score;

        });

        const updated_error = [...errors];
        if (updated_error[index]) {
            updated_error[index][field] = '';
        }
        setErrors(updated_error);
    };

    // handle save risk profile
    const _handleSave = () => {

        let is_valid = true;
        const updated_error = [...errors];

        styleScoreList.forEach((risk, index) => {
            if (risk.name.trim().length === 0) {
                updated_error[index].name = 'Please select risk profile';
                is_valid = false;
            }

            if (!risk.score_from === null) {
                updated_error[index].score_from = 'Please provide from';
                is_valid = false;
            }

            if (risk.score_to === null) {
                updated_error[index].score_to = 'Please provide to';
                is_valid = false;
            }
        });

        setErrors(updated_error);

        if (is_valid === true) {
            _riskProfileScore();
        }
    };


    // API - risk score
    const _riskProfileScore = () => {
        setLoader(true);
        let is_post = true;
        let url = 'manage-risk/score';
        let request = styleScoreList

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                navigate("/risk-assessment");
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setLoader(false);
        })
    };




    // API - Style score
    const _getStyleScore = () => {
        let is_post = false;
        let url = 'manage-risk/style-score';
        APIService(is_post, url).then((response) => {
            if (response.status_code === 200) {
                setStyleScoreList(response.data)
            }
            else {
                setStyleScoreList({})
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        })
    };



    return (
        <section className='e-section-height pb-5' >
            <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                    <span className='text-decoration-hover-underline cursor-pointer'
                        onClick={() => navigate("/risk-assessment")}>Manage Risk Assessment</span> / <span className='e-font-weight-600'>Set Risk Profile Score</span>
                </p>
            </div>

            {/* Set risk profile score */}
            <div className='padding-52px-lr margin--80px-top'>
                <div className='e-bg-white border-radius-16 padding-32px-all min-vh-50'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            Set risk profile score
                        </h4>
                        <PrimaryButton name="Save"
                            paddingBlock="padding-12px-tb padding-56px-lr"
                            loader={loader}
                            onClick={_handleSave} />
                    </div>

                    {/* Conservative */}
                    {styleScoreList.map((risk, key) => (
                        <div className='pt-4 row' key={key}>
                            <div className='col-4 pe-none opacity-75'>
                                <CustomTextInput label="Risk Profile"
                                    placeholder={risk.name}
                                    type="text"
                                    readOnly={true}
                                    required={true}
                                    value={risk.name}
                                    error={errors[key]?.name} // Update error prop to use errors[key].name
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSave}
                                    handleChange={(e) => {
                                        // _handleRiskScoreChange(e, "name", key)
                                    }} />
                            </div>
                            <div className='col-2'>
                                <CustomTextInput label="From"
                                    placeholder="2"
                                    type="number"
                                    required={true}
                                    value={risk.score_from}
                                    error={errors[key]?.score_from} // Update error prop to use errors[key].score_from
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSave}
                                    handleChange={(e) => _handleRiskScoreChange(e, "score_from", key)} />
                            </div>
                            <div className='col-2'>
                                <CustomTextInput label="To"
                                    placeholder="4"
                                    type="number"
                                    required={true}
                                    value={risk.score_to}
                                    error={errors[key]?.score_to} // Update error prop to use errors[key].score_to
                                    className="w-100"
                                    inputType={2}
                                    onKeyPress={_handleSave}
                                    handleChange={(e) => _handleRiskScoreChange(e, "score_to", key)} />
                            </div>
                        </div>
                    ))}



                </div>
            </div>
        </section>
    )
}

export default ManageRisk;
